// extracted by mini-css-extract-plugin
export default {"formHeading":"NJ-z","form":"OJ-z","submitBtn":"PJ-z","disabled":"QJ-z","input":"RJ-z","error":"SJ-z","submitMsg":"TJ-z","signIn":"UJ-z"};